/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default {
  init() {
    // alert('test');

    function setStoryImage(swiper) {
      const images = $('.story-image');
      images.each(function (index) {
        if (index === swiper.realIndex) {
          $(this).show(400);
        } else {
          $(this).hide(400);
        }
      });
    }

    function setProjectCard(swiper) {
      $('.current-index').text(`0${swiper.realIndex + 1}`);
      $('.total-slides').text(`0${swiper.slides.length}`);

      const cards = $('.project-card');

      cards.each(function (index) {
        if (index === swiper.realIndex) {
          $(this).slideDown(400);
        } else {
          $(this).slideUp(400);
        }
      });
    }

    const graduatesSwiper = new Swiper('.graduates-swiper', {
      // If we need pagination

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 0,
      on: {
        init: setStoryImage,
      },
    });

    graduatesSwiper.on('activeIndexChange', setStoryImage);

    const projectsSwiper = new Swiper('.projects-swiper', {
      // If we need pagination

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 0,
      on: {
        init: setProjectCard,
      },
    });
    projectsSwiper.on('activeIndexChange', setProjectCard);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateGraduates.js